import { render, staticRenderFns } from "./register.vue?vue&type=template&id=c309706a&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=c309706a&prod&lang=less&scoped=true&"
import style1 from "./register.vue?vue&type=style&index=1&id=c309706a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c309706a",
  null
  
)

export default component.exports